<template>
  <div class="enterprise-detail">
    <Title>我的简历</Title>
    <div class="enterprise-detail-main">
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-position="left"
      label-width="113px"
      class="my-form-lg-2"
    >
      <el-row :gutter="85">
        <el-col :span="8">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入您的姓名" show-word-limit maxlength="10"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="form.email" placeholder="请输入邮箱地址"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="85">
        <el-col :span="8">
          <el-form-item label="性别" prop="gender">
            <el-select v-model="form.gender">
              <el-option v-for="(item, index) in $genderEnum" :key="index" :value="item">{{ item }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出生日期" prop="birthdate">
            <el-date-picker v-model="form.birthdate" value-format="yyyy-MM-dd" :default-value="new Date(2000, 0, 1)"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="政治面貌" prop="politicalLandscape">
            <el-select v-model="form.politicalLandscape">
              <el-option v-for="(item, index) in $politicalLandscapeEnum" :key="index" :value="item">{{ item }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="85">
        <el-col :span="8">
          <el-form-item label="户籍" prop="homeAddress">
            <el-cascader
              v-model="form.homeAddress"
              :options="form.homeAddressList"
              placeholder="请选择户籍"
              collapse-tags
              :props="{ value: 'label' }"
              popper-class="my-cascader"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="最高学历" prop="education">
            <el-select v-model="form.education">
              <el-option v-for="(item, index) in $educationLevelEnum" :key="index" :value="item">{{ item }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="学校全称" prop="college">
            <el-input v-model="form.college" placeholder="请输入学校全称" show-word-limit maxlength="50"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="85">
        <el-col :span="8">
          <el-form-item label="专业" prop="major">
            <el-input v-model="form.major" placeholder="请输入毕业专业" show-word-limit maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="毕业时间" prop="graduationDate">
            <el-date-picker
              v-model="form.graduationDate"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职位类型" prop="posType">
            <el-select v-model="form.posType" placeholder="请选择职位类型">
              <el-option v-for="item in postTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <template v-if="isInternship">
          <el-col :span="8">
            <el-form-item label="可实习时间" prop="internshipDate">
              <el-date-picker
                v-model="form.internshipDate"
                key="internshipDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                start-placeholder="请选择"
                end-placeholder="请选择"
              >
              </el-date-picker>
              <span v-if="form.internshipDate" class="btn-clear" @click="form.internshipDate=null">清空</span>
              <div class="tips">*用于申请实习岗位</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="每周可实习" prop="practiceDays">
              <el-input
                v-model.trim="form.practiceDays"
                key="practiceDays"
                placeholder="请输入"
                maxlength="20"
                class="practiceDays"
                @change="onPracticeDaysChange"
                @blur="onPracticeDaysBlur"
              >
                <i slot="suffix" class="el-icon- el-input__icon"></i>
              </el-input>
              <div class="tips">*用于申请实习岗位</div>
            </el-form-item>
          </el-col>
        </template>
        <template v-if="isSocial">
          <el-col :span="8">
            <el-form-item prop="workDate" class="line-height-1">
              <template #label>
                <span>参加工作</span>
                <span style="margin-left: 28px;">年月</span>
              </template>
              <el-date-picker
                v-model="form.workDate"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="现所在公司" prop="workCompany">
              <el-input v-model="form.workCompany" placeholder="请输入现所在公司" show-word-limit maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="现所在部门" prop="workDept">
              <el-input v-model="form.workDept" placeholder="请输入现所在部门" show-word-limit maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="现职位" prop="workPosition">
              <el-input v-model="form.workPosition" placeholder="请输入现职位" show-word-limit maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
      <el-row type="flex" align="top">
        <el-col>
          <el-form-item label="简历上传" prop="resume">
            <Upload
              :fileList.sync="form.resume"
              isEdit
              preview
              @success="clearValidate('resume')"
              @remove="handleRemove(item.id)"
              :showTips="false"
              clearable
              fileTypeErrorMsg="仅支持格式为：pdf、zip、png，jpg，jpeg"
            >
              <div>点击上传</div>
              <template #tips
                >*仅支持格式为：pdf、zip、png，jpg，jpeg</template
              >
            </Upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="相关附件" prop="attachment">
            <Upload
              :fileList.sync="form.attachment"
              isEdit
              preview
              @success="clearValidate('attachment')"
              @remove="handleRemove(item.id)"
              :showTips="false"
              clearable
              fileTypeErrorMsg="仅支持格式为：pdf、zip、png，jpg，jpeg"
            >
              <div>点击上传</div>
              <template #tips
                >*仅支持格式为：pdf、zip、png，jpg，jpeg</template
              >
              <template #right-tips>*如有多个文件请打包上传</template>
            </Upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="相关链接" prop="hyperLink">
            <el-input
              type="textarea"
              v-model="form.hyperLink"
              placeholder="可输入Linkedin、GitHub、个人作品等链接，多个用回车键隔开"
              rows="8"
              show-word-limit
              maxlength="1000"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <Operation
      :showSaveBtn="false"
      :submitBtnText="isEdit ? '更新简历' : '提交'"
      :customSubmitHandler="isEdit ? handleUpdate : handleSubmit"
      class="operation"
    />
    <Preview
      v-if="showPreview"
      :visible.sync="showPreview"
      :data="previewData"
    />
  </div>
  </div>
</template>

<script>
import { resumeRules as rules } from "@/utils/validator";
import {getText as getPostTypeText} from '@/utils/enums/postTypeEnum'
import Operation from "@/components/Operation.vue";
import Preview from "@/components/Preview.vue";
import Upload from "./components/Upload.vue";
import Button from "@/components/Button.vue";
import Title from "@/components/Title.vue";

export default {
  components: {
    Operation,
    Preview,
    Upload,
    Button,
    Title,
  },

  data() {
    return {
      isEdit: false,
      form: {
        id: "",
        name: "", // 姓名
        phone: "", // 手机号码
        email: "", // 邮箱
        gender: "", // 性别
        birthdate: "", // 出生日期
        politicalLandscape: "", // 政治面貌
        homeAddress: "", // 户籍地址
        homeAddressList: [],
        education: "", // 最高学历
        college: "", // 学校全称
        major: "", // 专业
        graduationDate: "",
        internshipDate: "",
        practiceDays: "",
        majorList: [],
        hyperLink: "", // 相关链接
        resume: [], // 简历
        attachment: [], // 相关附件
        posType:this.$route.query.posType?Number(this.$route.query.posType):''
      },
      rules,
      showPreview: false,
      previewData: {},
    };
  },
  computed:{
    postTypes({$postTypeEnum,$utils}){
      return $utils.enumToOpts($postTypeEnum,getPostTypeText)
    },
    isCollege({form,$postTypeEnum}){
      return Number(form.posType)===$postTypeEnum.COLLEGE
    },
    isInternship({form,$postTypeEnum}){
      return Number(form.posType)===$postTypeEnum.INTERNSHIP
    },
    isSocial({form,$postTypeEnum}){
      return Number(form.posType)===$postTypeEnum.SOCIAL
    },
  },
  watch:{
    'form.internshipDate'(val,oldVal){
      if(!val){
        if(!this.onIntershipDateClear()){
          this.form.internshipDate=oldVal
        }
      }
    },
  },
  created() {
    this.getData();
    this.getCity()
    // this.getPositionType()
  },

  methods: {
    async getData() {
      console.log("sliudhvlsuidbvs");
      // let { data } = await this.$api.resumeDetail({phone:'13183134558'});
      let { data } = await this.$api.resumeDetail();
      this.isEdit = data.id != 0
      if (!this.isEdit) return;
      console.log("data",data.userName);
      let{formatDate}=this.$utils
      this.form = {
        ...this.form,
        id:data.id,
        name: data.userName, // 姓名
        phone: data.telephone, // 手机号码
        email: data.email, // 邮箱
        gender: data.sex, // 性别
        birthdate: data.birthday, // 出生日期
        politicalLandscape: data.political, // 政治面貌
        homeAddress: data.registered, // 户籍地址
        education: data.degree, // 最高学历
        college: data.school, // 学校全称
        major: data.major, // 专业
        graduationDate: data.graduationDate ? formatDate(data.graduationDate) : '',
        internshipDate: data.practiceStartDate && data.practiceEndDate ? [formatDate(data.practiceStartDate),formatDate(data.practiceEndDate)] : '',
        practiceDays: data.practiceDays,
        originalPracticeDays: data.practiceDays,
        hyperLink: data.hyperLink, // 相关链接
        resume: [], // 简历
        attachment: [], // 相关附件
        deliverPractice: data.deliverPractice,
        posType:this.$route.query.posType?Number(this.$route.query.posType):Number(data.posType),
        workDate:data.workDate,
        workCompany:data.workCompany,
        workDept:data.workDept,
        workPosition:data.workPosition,
      };
      let{resumeFileId,resumeFileName,resumeFileUrl}=data
      if(resumeFileId||resumeFileName||resumeFileUrl){
        this.form.resume=[{
          id: resumeFileId,
          name: resumeFileName,
          url: resumeFileUrl,
        }]
      }
      let{otherFileId,otherFileName,otherFileUrl}=data
      if(otherFileId||otherFileName||otherFileUrl){
        this.form.attachment=[{
          id: otherFileId,
          name: otherFileName,
          url: otherFileUrl,
        }]
      }
    },
    handleRemove(id){
      
      console.log('handleRemove',id);
      return;
    },
    getQueryParams() {
      let {
        name, // 职位类型
        phone, // 职位名称
        email, // 职位类别
        gender, // 职责描述
        birthdate, // 任职要求
        politicalLandscape, // 专业要求
        homeAddress, // 企业简称
        college, // 所在城市
        education, // 所在城市
        major, // 所在城市
        hyperLink, // 所在城市
        resume, // 所在城市
        attachment, // 所在城市
        graduationDate,
        internshipDate,
        practiceDays,
        posType,
        workDate,
        workCompany,
        workDept,
        workPosition,
      } = this.form;
      const params = {
        userName:name, // 姓名
        telephone:phone, // 手机号码
        email, // 邮箱
        sex:gender, // 性别
        birthday:this.$utils.formatDate(birthdate), // 出生日期
        political:politicalLandscape, // 政治面貌
        registered:homeAddress, // 户籍地址
        degree:education, // 最高学历
        school:college, // 学校全称
        major, // 专业
        graduationDate,
        hyperLink, // 相关链接
        resumeFileId:resume[0]?.id||'',
        otherFileId:attachment[0]?.id||'',
        posType,
        practiceStartDate:null,
        practiceEndDate:null,
        practiceDays:'',
        workDate:null,
        workCompany:'',
        workDept:'',
        workPosition:'',
        practiceStartDate:internshipDate?.[0],
        practiceEndDate:internshipDate?.[1],
        practiceDays,
        workDate,
        workCompany,
        workDept,
        workPosition,
      }
      return params
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        
        let { success, msg } = await this.$api.addResume(this.getQueryParams());
        if (success) {
          this.$message.success(msg);
          setTimeout(() => {
            this.$router.push('/')
          }, 2000)
        }
      } catch (err) {
        console.error(err);
      }
    },
    async handleUpdate() {
      try {
        await this.$refs.form.validate();
        let {
          id,
        } = this.form;
        let { success, msg } = await this.$api.updateResume({
          id,
          ...this.getQueryParams(),
        });
        if (success) {
          this.$message.success(msg);
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getCity() {
      let { data } = await this.$api.city();
      this.form.homeAddressList = data.map((item) => {
        let children = item.cityChild;
        if (children) {
          item.children = children.map((subItem) => {
            return {
              label: subItem.name,
              value: subItem.id,
            };
          });
        }
        return {
          label: item.name,
          value: item.id,
          children: item.children,
        };
      });
    },
    // 获取专业
    async getPositionType() {
      let { data } = await this.$api.positionType();
      this.form.majorList = data.majorType.map((item) => {
        let { code, name } = item;
        return {
          label: name,
          value: code,
        };
      });
    },
    onIntershipDateClear(){
      if(this.form.deliverPractice){
        this.$message.error('您已投递实习岗位，无法清除可实习时间哦~')
        return false
      }
      this.form.internshipDate=''
      return true
    },
    onPracticeDaysChange(val){
      if(val){
        this.form.originalPracticeDays=val
      }
    },
    onPracticeDaysBlur(e){
      if(this.form.deliverPractice&&!e.target.value){
        this.form.practiceDays = this.form.originalPracticeDays
        this.$message.error('您已投递实习岗位，无法清除每周可实习天数哦~')
      }
    },
    clearValidate(field){
      this.$refs.form.clearValidate(field)
    }
  },
};
</script>

<style lang="scss" scoped>
.enterprise-detail {
  &-main {
    box-sizing: border-box;
    padding: 60px 30px;
    height: 1091px;
    .operation {
      margin-top: 64px;
      height: auto;
    }
  }
  /deep/ .el-form-item {
    &.line-height-1 {
      .el-form-item__label {
        @extend .line-height-1;
      }
    }
    &-hide-label-icon {
      .el-form-item__label {
        &::before {
          display: none;
        }
      }
    }
    &.creditCode {
      .el-form-item__label {
        &::before {
          position: relative;
          bottom: 2px;
        }
      }
    }
  }
  /deep/ .el-form-item__label {
    @extend .f18;
  }
  /deep/ .el-form-item__content {
    .el-input {
      @extend .f18;
    }
    .el-select {
      width: 100%;
      .el-tag {
        @extend .f18;
      }
    }
    .el-cascader {
      width: 100%;
      .el-tag {
        @extend .f18;
      }
    }
    .el-date-editor {
      width: 100%;
    }
  }
  .logo.finish {
    width: 153px;
    /deep/ .cover-detail {
      height: 47px;
    }
  }
  .btn {
    margin-top: 30px;
    padding: 0;
    width: 81px;
    height: 30px;
    @extend .f14;
    &-add {
      //   margin: 30px 0;
    }
    &-row {
      display: inline-block;
      width: 100%;
    }
    &-clear{
      position:absolute;
      padding-left: 4px;
      color: #409EFF;
      white-space: nowrap;
      cursor: pointer;
    }
  }
  /deep/ .tips-right {
    margin-left: 12px;
    @extend .f14;
    font-weight: 400;
    color: #c4c4c4;
    line-height: 16px;
  }
  /deep/ .preview-btn {
    &::before {
      display: none;
    }
    span {
      font-size: 16px;
    }
  }
  /deep/ .icon-update {
    &::before {
      content: "";
      margin: 0 12px;
      width: 1px;
      height: 13px;
      opacity: 1;
      background: #c0c4cc;
    }    
  }
}
.tips {
  margin: 8px 0 0;
  color: #fa5151;
  line-height: 1;
}
.el-input {
  &.practiceDays {
    /deep/ .el-input__icon {
      &::before {
        content: "天";
      }
    }
  }
}
</style>